import { ApplicationByStaff } from 'models/applications/applications';

import { ApplicationState } from '../../../models/applications/enum';

export const isApplicationHasStatusWorkOrHigher = (
  state: ApplicationState,
  application?: ApplicationByStaff
) => {
  if (application?.epguInfo?.createdFromEpgu) {
    return state !== ApplicationState.DRAFT;
  }
  return (
    state !== ApplicationState.DRAFT &&
    state !== ApplicationState.UNDER_CONSIDERATION
  );
};
